import { createSlice } from '@reduxjs/toolkit';
import lodash from 'lodash';

const initialState = {
  tabItems: [],
  tabItemsExpend: [],
  listItems: [],
  contentTitle: '',
  contentSubTitle: '',
  isMobile: false,
  isShowPopUp: false,
  isShowContent: true
};

const tabsContainerSlice = createSlice({
  name: 'tabsContainer',
  initialState,
  reducers: {
    resetBlock: () => initialState,

    setPopUp: (state, action) => {
      state.isShowPopUp = action.payload.status;
    },
    setTabItems: (state, action) => {
      state.tabItems = action.payload.items;
    },
    setTabItemsExpend: (state, action) => {
      state.tabItemsExpend = action.payload.items;
    },
    reportAnalytics: (state, action) => { },
    activateTab: (state, action) => {

      let items = lodash.cloneDeep(action.payload.items);

      for (let i = 0; i < items.length; i++) {
        if (action.payload.id == items[i].id) {

          if (items[i].active == true) {
            items[i].active = false;
            state.isShowContent = false;
          }
          else {
            items[i].active = true;
            state.isShowContent = true;

            if (!action.payload.isMobile) {

              const container = document.querySelector(`.content`);

              if (container !== null) {
                container.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                });
              }
            }
          }

          state.contentTitle = items[i].contentTitle;
          state.contentSubTitle = items[i].subContentTitle;
          state.listItems = items[i].listItems;
        }
        else
          items[i].active = false;
      }

      if (action.payload.isMobile)
        state.isShowPopUp = true;
      else
        state.isShowPopUp = false;

      state.isMobile = action.payload.isMobile;
      state.tabItems = items;
    },

  },
});

export const { setTabItems, setTabItemsExpend, activateTab, setPopUp, resetBlock, reportAnalytics } = tabsContainerSlice.actions;
export default tabsContainerSlice.reducer;
